module.exports = __webpack_public_path__ + "next2.jpg?37808fe111ece917a51fff1f061e7a8e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/next2.jpg
// module id = 105
// module chunks = 0